export const CicDisclosureColumnId = {
  EXPAND: 'expand',
  DISCLOSURE: 'disclosure',
  SENT: 'sent',
  DELIVERY: 'delivery',
  DOCUMENTS: 'documents',
};
